// extracted by mini-css-extract-plugin
export default {"PromoCodeInfo":"PromoCodeInfo_PromoCodeInfo__91rF+"};